import React from 'react';
import { FaGithub } from 'react-icons/fa';
import { HiArrowRight } from 'react-icons/hi';
import { Link, useNavigate } from 'react-router-dom';
import { contactsData } from '../../../data/contactsData';
import { projectsData } from '../../../data/projectsData';
import { slugForId } from '../../../utils/projectSlug';
import SingleProject from '../../container/single-project';
import { withViewTransition } from '../../../utils/viewTransition';
import Reveal from '../../helper/reveal';
import './projects.css';

const HOME_LIMIT = 6;

function ProjectsUI() {
    const navigate = useNavigate();
    if (projectsData.length === 0) return null;

    // Plain clicks animate the page change; ctrl/cmd/shift/middle clicks keep the browser default.
    const openAll = (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        withViewTransition(() => navigate('/projects'), 'route');
    };

    return (
        <section className='section projects' id='projects' aria-labelledby='projects-title'>
            <div className='container'>
                <Reveal className='section-head'>
                    <span className='eyebrow'>08 / Featured projects</span>
                    <h2 id='projects-title' className='section-title'>Selected work.</h2>
                </Reveal>

                <div className='projects__grid'>
                    {projectsData.map((project, index) => (
                        <SingleProject
                            key={project.id}
                            index={index}
                            id={project.id}
                            name={project.projectName}
                            desc={project.projectDesc}
                            tags={project.tags}
                            code={project.code}
                            slug={slugForId(project.id)}
                            printOnly={index >= HOME_LIMIT}
                        />
                    ))}
                </div>

                <div className='projects__footer'>
                    {projectsData.length > HOME_LIMIT && (
                        <Link to='/projects' className='btn' onClick={openAll}>
                            All projects ({projectsData.length})
                            <HiArrowRight aria-hidden='true' />
                        </Link>
                    )}
                    {contactsData.github && (
                        <a href={contactsData.github} target='_blank' rel='noreferrer' className='btn'>
                            <FaGithub aria-hidden='true' />
                            More on GitHub
                        </a>
                    )}
                </div>
            </div>
        </section>
    );
}

export default ProjectsUI;
